/**
 * "Show the app as this role" (owner's permissions plan, 3 Oct 2026: "قبل ما تحفظ، تفتح البرنامج بصلاحيات أي دور وتشوف
 * بالظبط هو هيشوف إيه. للأدمن بس، ومابيغيّرش حاجة"): an admin sees the menus, tabs and buttons a role would see. Nothing
 * is saved anywhere and nothing changes for anyone - it lives in this browser tab only, until "Exit".
 *   viewAsRole.set({ roleId, name, permissions }) / viewAsRole.clear() / viewAsRole.get() / viewAsRole.subscribe(fn)
 */
const KEY = 'yelo.viewAsRole';
const subscribers = new Set();

const read = () => {
    try {
        const v = JSON.parse(window.sessionStorage.getItem(KEY) || 'null');
        return v && v.roleId && Array.isArray(v.permissions) ? v : null;
    } catch {
        return null;
    }
};

let state = read();

const publish = () => subscribers.forEach((fn) => fn());

export const viewAsRole = {
    get: () => state,
    set: ({ roleId, name, permissions }) => {
        state = { roleId, name: name || roleId, permissions: [...(permissions || [])] };
        try { window.sessionStorage.setItem(KEY, JSON.stringify(state)); } catch { /* the view still works this session */ }
        publish();
    },
    clear: () => {
        state = null;
        try { window.sessionStorage.removeItem(KEY); } catch { /* nothing kept */ }
        publish();
    },
    subscribe: (fn) => {
        subscribers.add(fn);
        return () => subscribers.delete(fn);
    },
};

/**
 * The Role Management edits not saved yet, kept while the admin looks at the app as a role and given back once on
 * return (review 3 Oct 2026). `basedOn` = the roles they were made on: a draft whose roles were saved meanwhile (another
 * tab, another admin) is dropped, never restored over them. Cleared on sign-out.
 */
const DRAFT_KEY = 'yelo.rolesDraft';
export const rolesSignature = (roles) => JSON.stringify(Object.keys(roles || {}).sort()
    .map((id) => [id, roles[id]?.name || '', [...(roles[id]?.permissions || [])].sort()]));
export const rolesDraft = {
    save: ({ roles, selectedRole, basedOn }) => {
        try { window.sessionStorage.setItem(DRAFT_KEY, JSON.stringify({ roles, selectedRole, basedOn: rolesSignature(basedOn) })); } catch { /* not kept */ }
    },
    /** The draft, once (it is removed); null when there is none. */
    take: () => {
        try {
            const d = JSON.parse(window.sessionStorage.getItem(DRAFT_KEY) || 'null');
            window.sessionStorage.removeItem(DRAFT_KEY);
            return d && d.roles && typeof d.roles === 'object' ? d : null;
        } catch {
            return null;
        }
    },
    clear: () => { try { window.sessionStorage.removeItem(DRAFT_KEY); } catch { /* nothing kept */ } },
};
